import React from 'react'
import { createNgReactBridgeDirective } from '../../../react-bridge'
import { ArchiveDialog } from '../../../../components/applications-grid/actions/archive-dialog'
import { getApplicationsRoute, updateRoute } from '../../../../components/route'

interface Application {
  readonly app_id: string
  readonly archived: boolean
  readonly name: string
}

export interface ArchiveDialogProps {
  readonly application: Application
  readonly closeDialog: () => void
  readonly isOpen: boolean
  readonly organizationID: string
}

export function ArchiveDialogBridge({
  application,
  closeDialog,
  isOpen,
  organizationID
}: ArchiveDialogProps) {
  if (!organizationID) {
    throw new Error('organizationID is required')
  }
  if (!application) {
    throw new Error('application is required')
  }
  if (
    typeof application.archived !== 'boolean' ||
    !application.app_id ||
    !application.name
  ) {
    throw new Error('application is required to have {app_id, archived, name}')
  }
  if (typeof isOpen !== 'boolean') {
    throw new Error('isOpen is required and must be a boolean')
  }
  if (typeof closeDialog !== 'function') {
    throw new Error('closeDialog is required and must be a function')
  }

  return isOpen && !application.archived ? (
    <ArchiveDialog
      applicationID={application.app_id}
      refresh={() => {
        updateRoute(getApplicationsRoute(organizationID))
        return Promise.resolve()
      }}
      applicationName={application.name}
      closeDialog={closeDialog}
      isOpen={isOpen}
      organizationID={organizationID}
      refetchQueries={[]}
    />
  ) : null
}

export const reactArchiveDialog = createNgReactBridgeDirective(
  'reactArchiveDialog',
  [],
  ArchiveDialogBridge,
  ['application', 'closeDialog', 'isOpen', 'organizationID']
)
